import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { requestPasswordReset } from '../auth/authApi';

const ForgotPasswordLayer = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await requestPasswordReset({ email });
      setSubmitted(true);
    } catch (err) {
      setError('Failed to send reset link');
    }
  };

  return (
    <div
      className='signup-page-background'
      style={{
        backgroundColor: '#f7f7f7',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >

      {/* Header */}
      <header 
        className="shadow-sm py-3 px-24 d-flex align-items-center"
        >
        <Link to="/" className="d-inline-block">
          <img
            src="/assets/images/logo_neg.png"
            alt="Logo"
            style={{ height: '40px', objectFit: 'contain' }}
          />
        </Link>
      </header>

      {/* Main Content */}
      <section
        className="auth forgot-password-page d-flex justify-content-center pt-4 px-3"
        style={{
          flex: 1,
          overflowY: 'auto',
          minHeight: 0,
        }}
      >
        <div className="d-flex flex-column">
          <div className="p-32 m-32 max-w-500-px w-100 border rounded-2 text-center bg-white">
            {!submitted ? (
              <>
                <div className="text-center p-16 d-flex flex-column align-items-center">
                  <div
                    className="d-flex align-items-center justify-content-center rounded-circle mb-32 bg-primary-100 text-primary"
                    style={{ width: "90px", height: "90px" }}
                  >
                    <Icon icon='mage:key' style={{ fontSize: "54px" }} />
                  </div>
                </div>
                <h5 className="mb-24">Need a new Password?</h5>
                <p className="mb-32 text-secondary-light text-lg">
                  Please enter the email address and we'll send you a link to reset your password.
                </p>
                <form onSubmit={handleSubmit}>
                  <div className="icon-field text-start">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="mage:email" />
                    </span>
                    <input
                      type="email"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      placeholder="Enter Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                  {error && <div className="text-danger mt-2">{error}</div>}

                  <button
                    type="submit"
                    className="btn btn-primary text-sm btn-sm px-12 py-12 w-50 radius-12 mt-32"
                  >
                    Get Password
                  </button>
                  <div className="text-center mt-24">
                    <Link to="/sign-in" className="text-primary-600 fw-bold">
                      Back to Sign In
                    </Link>
                  </div>

                  <div className="mt-120 text-center text-sm">
                    <p className="mb-0">
                      Don't have an account?{' '}
                      <Link to="/sign-up" className="text-primary-600 fw-semibold">
                        Sign Up
                      </Link>
                    </p>
                  </div>
                </form>
              </>
            ) : (
              <div className="text-center">
                <div className="text-center p-16 d-flex flex-column align-items-center">
                  <div
                    className="d-flex align-items-center justify-content-center rounded-circle mb-32 bg-primary-100 text-primary"
                    style={{ width: "90px", height: "90px" }}
                  >
                    <Icon icon='mdi:mail' style={{ fontSize: "54px" }} />
                  </div>
                </div>
                <h5 className="mb-12">Check your inbox</h5>
                <p className="text-secondary-light mb-32 text-lg">
                  We have sent an email containing instructions on how to change your password to the email address you supplied.
                </p>

                <div className="mt-120 text-center text-sm">
                  <p className="mb-0">
                    Don’t have an account?{' '}
                    <Link to="/sign-up" className="text-primary-600 fw-semibold">
                      Create one
                    </Link>{' '}
                    or{' '}
                    <Link to="/sign-in" className="text-primary-600 fw-semibold">
                      Sign in
                    </Link>
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
      <footer className="text-center py-3">
        <small className="text-white">© {new Date().getFullYear()} Samurai CMMS</small>
      </footer>
    </div>
  );
};

export default ForgotPasswordLayer;
